/* CILSON – Produktseite: Badges in einer Reihe, Farbnamen in den Kästchen */
(() => {
  if (window.cilsonPdpExtra) return;
  window.cilsonPdpExtra = true;

  const badges = () => {
    const title = document.querySelector('.product__info-container > .product__title');
    if (!title) return;
    const best = title.querySelector('.cil-best-pdp');
    const mig = title.querySelector('.cil-mig2');
    if (!best || !mig) return;
    let wrap = title.querySelector('.cil-badges');
    if (!wrap) {
      wrap = document.createElement('div');
      wrap.className = 'cil-badges';
      best.insertAdjacentElement('beforebegin', wrap);
    }
    if (best.parentElement !== wrap) wrap.insertAdjacentElement('afterbegin', best);
    if (best.nextElementSibling !== mig) best.insertAdjacentElement('afterend', mig);
  };

  const colors = () => {
    document.querySelectorAll('.product__info-container .cil-dot').forEach((d) => {
      if (d.querySelector('.cil-dot-l')) return;
      const name = (d.getAttribute('title') || d.getAttribute('aria-label') || '').trim();
      if (!name) return;
      const s = document.createElement('span');
      s.className = 'cil-dot-l';
      s.textContent = name;
      d.appendChild(s);
    });
  };

  const run = () => { badges(); colors(); };
  let t;
  const start = () => {
    run();
    [300, 900, 1800, 3500].forEach((ms) => setTimeout(run, ms));
    const root = document.querySelector('.product__info-container');
    if (root) new MutationObserver(() => { clearTimeout(t); t = setTimeout(run, 60); }).observe(root, { childList: true, subtree: true });
  };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start);
  else start();
})();
